import React from 'react';

/**
 * Hook that increments a count value.
 * @returns {[number, React.Dispatch<React.SetStateAction<number>>]} An array with count as the first value and dispatcher as the second.
 */
const useIncrement = () => {
  const [count, dispatch] = React.useReducer((count) => ++count, 0);
  return [count, dispatch];
};

export default useIncrement;